import React from "react";
import {IMAGES, KButton, KCard, KContainer, KSpace} from "@kopjra/uikit";
import {I18n, Translate} from "react-redux-i18n";
import {Alert, Col, Row} from "react-bootstrap";
import {AREAS} from "../types/solutions";
import {navigate, Routes} from "../utils/router";

export interface StateProps {
}

export interface DispatchProps {
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

export const Home: React.FC<Props> = () => {
    const alertText = I18n.t("globalAlert", {dangerousHTML: true});

    return (
        <KContainer>
            <h5><img src={IMAGES.kopjra.still.small.default} height={85} alt="kopjra logo"/></h5>
            <h3><Translate value="home.title"/></h3>
            <h4><Translate value="home.subtitle" dangerousHTML={true}/></h4>
            {alertText && alertText !== "globalAlert" && <Alert variant="warning" style={{textAlign: "center"}}><Translate value={"globalAlert"} dangerousHTML={true}/></Alert>}
            <KSpace spaces={3}/>
            <Row>
                {AREAS.map((area, index) => (
                    <Col lg={4} key={index}>
                        <KCard fillHeight={true}>
                            <h5><img src={I18n.t(`areas.${area}.logo`)} height={70} alt={area}/></h5>
                            {/*<h5><Translate value={`areas.${area}.name`}/></h5>*/}
                            <KSpace spaces={1.5}/>
                            <h6><Translate value={`areas.${area}.description`} dangerousHTML={true}/></h6>
                            <KSpace spaces={1.5}/>
                            <div className="mt-auto">
                                <KButton id={"home-conf-buy"} text={<Translate value={`areas.${area}.cta`} />} onClick={() => navigate(Routes.AREA(area))} fill={true}/>
                            </div>
                        </KCard>
                    </Col>
                ))}
            </Row>
            <KSpace spaces={3}/>
            <h4><a className="link" href={"https://estimator.kopjra.com"} target="_blank" rel="noopener noreferrer"><Translate value="home.contactus"/></a></h4>
            <KSpace spaces={2}/>
        </KContainer>
    );
}
